"use client";

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/Button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
export default function CTA() {
  const $ = _c(54);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      threshold: 0.3
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    ref,
    isVisible
  } = useScrollAnimation(t0);
  const t1 = ref as React.RefObject<HTMLElement>;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 overflow-hidden"><div className="absolute top-1/4 left-1/4 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-blob" /><div className="absolute top-1/3 right-1/4 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-blob animation-delay-2000" /><div className="absolute bottom-1/4 left-1/2 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-10 animate-blob animation-delay-4000" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      y: 30
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isVisible) {
    t4 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[3] = isVisible;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 0.8
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      scale: 0.8
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isVisible) {
    t7 = isVisible ? {
      opacity: 1,
      scale: 1
    } : {};
    $[7] = isVisible;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      duration: 0.6,
      delay: 0.2
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Sparkles className="w-4 h-4" />;
    t10 = <span>Join 10,000+ Successful Students</span>;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== t7) {
    t11 = <motion.div initial={t6} animate={t7} transition={t8} className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">{t9}{t10}</motion.div>;
    $[12] = t7;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      y: 20
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== isVisible) {
    t13 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[15] = isVisible;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      duration: 0.6,
      delay: 0.3
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="block">Your Future?</span>;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t13) {
    t16 = <motion.h2 initial={t12} animate={t13} transition={t14} className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">Ready to Transform{t15}</motion.h2>;
    $[19] = t13;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      opacity: 0,
      y: 20
    };
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  let t18;
  if ($[22] !== isVisible) {
    t18 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[22] = isVisible;
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  let t19;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      duration: 0.6,
      delay: 0.4
    };
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t18) {
    t20 = <motion.p initial={t17} animate={t18} transition={t19} className="text-xl md:text-2xl text-blue-100 mb-10 max-w-2xl mx-auto">Start learning today and get matched to your dream opportunity. No credit card required.</motion.p>;
    $[25] = t18;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = {
      opacity: 0,
      y: 20
    };
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== isVisible) {
    t22 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[28] = isVisible;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = {
      duration: 0.6,
      delay: 0.5
    };
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  let t25;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Button size="xl" className="bg-white text-blue-600 hover:bg-gray-100 shadow-2xl group">Get Started Free<ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" /></Button>;
    t25 = <Button size="xl" variant="outline" className="border-2 border-white text-white hover:bg-white/10">Explore Courses</Button>;
    $[31] = t24;
    $[32] = t25;
  } else {
    t24 = $[31];
    t25 = $[32];
  }
  let t26;
  if ($[33] !== t22) {
    t26 = <motion.div initial={t21} animate={t22} transition={t23} className="flex flex-col sm:flex-row gap-4 justify-center items-center">{t24}{t25}</motion.div>;
    $[33] = t22;
    $[34] = t26;
  } else {
    t26 = $[34];
  }
  let t27;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      opacity: 0,
      y: 20
    };
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  let t28;
  if ($[36] !== isVisible) {
    t28 = isVisible ? {
      opacity: 1,
      y: 0
    } : {};
    $[36] = isVisible;
    $[37] = t28;
  } else {
    t28 = $[37];
  }
  let t29;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      duration: 0.6,
      delay: 0.6
    };
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  let t30;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <div className="flex items-center gap-2"><svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg><span>No Credit Card Required</span></div>;
    $[39] = t30;
  } else {
    t30 = $[39];
  }
  let t31;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="flex items-center gap-2"><svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg><span>Cancel Anytime</span></div>;
    $[40] = t31;
  } else {
    t31 = $[40];
  }
  let t32;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="flex items-center gap-2"><svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg><span>Money-Back Guarantee</span></div>;
    $[41] = t32;
  } else {
    t32 = $[41];
  }
  let t33;
  if ($[42] !== t28) {
    t33 = <motion.div initial={t27} animate={t28} transition={t29} className="mt-12 flex flex-wrap justify-center gap-8 text-white/80 text-sm">{t30}{t31}{t32}</motion.div>;
    $[42] = t28;
    $[43] = t33;
  } else {
    t33 = $[43];
  }
  let t34;
  if ($[44] !== t11 || $[45] !== t16 || $[46] !== t20 || $[47] !== t26 || $[48] !== t33 || $[49] !== t4) {
    t34 = <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10"><motion.div initial={t3} animate={t4} transition={t5} className="text-center">{t11}{t16}{t20}{t26}{t33}</motion.div></div>;
    $[44] = t11;
    $[45] = t16;
    $[46] = t20;
    $[47] = t26;
    $[48] = t33;
    $[49] = t4;
    $[50] = t34;
  } else {
    t34 = $[50];
  }
  let t35;
  if ($[51] !== t1 || $[52] !== t34) {
    t35 = <section className="py-20 md:py-32 bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 relative overflow-hidden" ref={t1}>{t2}{t34}</section>;
    $[51] = t1;
    $[52] = t34;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  return t35;
}